import { useMemo } from 'react'
import MultiSelect from '../inputs/MultiSelect'
import './CodeFilterPopover.css'

// Inline filter panel for the Library nav, docked above the section list.
// Facets: Author / Text type, plus a label search and bookmarked-only.
// Match, the topic field, and the Filter header sit above this panel.
function CodeFilterPanel({
  values,
  onChange,
  text,
  onTextChange,
  bookmarkedOnly,
  onBookmarkedOnlyChange,
  authorOptions,
  textTypeOptions,
}) {
  const facets = useMemo(
    () => [
      {
        key: 'authors',
        label: 'Author',
        options: authorOptions,
        placeholder: 'Any author',
        getOptionValue: (a) => a._id,
        getOptionLabel: (a) => a.label,
      },
      {
        key: 'types',
        label: 'Text type',
        options: textTypeOptions,
        placeholder: 'Any type',
        getOptionValue: (t) => t._id,
        getOptionLabel: (t) => t.label,
      },
    ],
    [authorOptions, textTypeOptions]
  )

  return (
    <div className="nav-filter-panel" role="group" aria-label="Filter library">
      <div className="nav-filter-body">
        <div className="code-filter-facet">
          <span className="code-filter-label">Search labels</span>
          <input
            className="ct-input"
            type="text"
            value={text}
            placeholder="e.g. reb cover"
            onChange={(event) => onTextChange(event.target.value)}
          />
        </div>

        {facets.map((facet) => (
          <div className="code-filter-facet" key={facet.key}>
            <span className="code-filter-label">{facet.label}</span>
            <MultiSelect
              value={values[facet.key] || []}
              onChange={(next) => onChange(facet.key, next)}
              options={facet.options || []}
              placeholder={facet.placeholder}
              getOptionValue={facet.getOptionValue}
              getOptionLabel={facet.getOptionLabel}
            />
          </div>
        ))}

        <label className="code-filter-check">
          <input
            type="checkbox"
            checked={bookmarkedOnly}
            onChange={(event) => onBookmarkedOnlyChange(event.target.checked)}
          />
          Bookmarked only
        </label>
      </div>
    </div>
  )
}

export default CodeFilterPanel
